// removed by extract-text-webpack-plugin
module.exports = {"footer":"Sq0kFMNqtMrFaZ75o1K-8"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/MigrationBoxFooter.scss
// module id = 2653
// module chunks = 0